export default {
  background_image: 'Image de fond',
};
